import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaterialTable from '@material-table/core';
import { useHistory } from 'react-router-dom';
import localization from "../../localisation.json";

function PersonPage() {
  let history = useHistory();
  let { id } = useParams();

  const [data, setData] = useState({name: "", additional_info: "-", occs: [], places: [], pubs: []});

  useEffect(() => {
    function fetchPageData() {
      fetch("http://medpub-backend-dmpn.ext.ocp-prod-0.k8s.it.helsinki.fi/person/" + id)
      .then(res => res.json())
      .then(result => setData(result))
      .catch(console.log);
    }
    fetchPageData();
  }, [id]);

  return (
    <div className="home">
      <div class="entity-page-container">
        <div class="page-header">
          <img src="register-people.png" alt="" />
          <h1>{data.name}</h1>
        </div>
        <div class="row entity-page-content justify-content-start">
          <div class="col-lg-2">
            <p>
              Person ID: {id}
            </p>
            <p>
              Stations: {data.occs.length}
            </p>
            <p>
              Notes: {data.additional_info}
            </p>
          </div>
          <div class="col-lg-10">
            <p>
              <h4>Places connected:</h4>
            </p>
            <p>
              <MaterialTable
                columns={[
                  { title: "ID", field: "id"},
                  { title: "Name", field: "name" }
                ]}
                data={data.places}
                options={{
                  toolbar: false,
                  header: true,
                  columnsButton: false,
                  exportButton: false,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#1b437e',
                    color: '#FFF'
                  },
                }}
                localization={localization}
                onRowClick={((evt, selectedRow) => {
                  history.push('/place/' + selectedRow.id)
                })}
              />
            </p>
            <p>
              <h4>Biographical data:</h4>
            </p>
            <p>
              <MaterialTable
                columns={[
                  { title: "ID", field: "id"},
                  { title: "Station", field: "occ_name" },
                  { title: "Place", field: "place_name" },
                  { title: "Order", field: "order_short" },
                  { title: "Notes", field: "additional_info" },
                ]}
                data={data.occs}
                options={{
                  toolbar: false,
                  header: true,
                  columnsButton: false,
                  exportButton: false,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#1b437e',
                    color: '#FFF'
                  },
                }}
                localization={localization}
                onRowClick={((evt, selectedRow) => {
                  history.push('/place/' + selectedRow.id)
                })}
              />
            </p>
            <p>
              <h4>Works connected:</h4>
            </p>
            <p>
              <MaterialTable
                columns={[
                  { title: 'Publication ID', field: "id"},
                  { title: 'Work ID', field: "work_id" },
                  { title: 'Title', field: "title" },
                  { title: 'Station', field: "in_occ" },
                  { title: 'Role', field: "role_name" },
                  { title: 'Authorial status', field: "authorial_status" }
                ]}
                data={data.pubs}
                options={{
                  toolbar: false,
                  header: true,
                  columnsButton: false,
                  exportButton: false,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#1b437e',
                    color: '#FFF'
                  },
                }}
                localization={localization}
                onRowClick={((evt, selectedRow) => {
                  history.push('/work/' + selectedRow.work_id)
                })}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersonPage;